import { Button, Container, Form, FormField, Multiselect, SelectProps } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect } from 'react';
import { CustomAppLayout } from '../../../layout';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiFileExcel } from '@mdi/js';
import Icon from '@mdi/react';
import * as XLSX from "xlsx";
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';


type OptionDefinition = SelectProps.Option;

export const DownloadsBookingsPage = () => {
    const { data, menu, parameters } = useGlobalState();


    const [selectedBookingTypes, setSelectedBookingTypes] = React.useState<OptionDefinition[]>([]);
    const [listBookingTypes, setListBookingTypes] = React.useState<OptionDefinition[]>([]);

    const [selectedGroupTypes, setSelectedGroupTypes] = React.useState<OptionDefinition[]>([]);
    const [listGroupTypes, setListGroupTypes] = React.useState<OptionDefinition[]>([]);

    const [selectedCategories, setSelectedCategories] = React.useState<OptionDefinition[]>([]);
    const [listCategories, setListCategories] = React.useState<OptionDefinition[]>([]);




    useEffect(() => {
        //handleRefreshMovements();
    }, [parameters.month]); //parameters.startDate, parameters.endDate, 

    useEffect(() => {

    }, [parameters]);

    useEffect(() => {
        const ids: OptionDefinition[] = data.bookingTypes.map((item: { idBookingType: any; bookingType: any; }) => ({
            value: item.idBookingType,   // map idCheck → value
            label: item.bookingType      // map check → label
        }));
        setListBookingTypes(ids)
        const ids2: OptionDefinition[] = data.groupTypes.map((item: { idGroupType: any; groupType: any; }) => ({
            value: item.idGroupType,   // map idCheck → value
            label: item.groupType      // map check → label
        }));
        setListGroupTypes(ids2)
        const ids3: OptionDefinition[] = data.categories.map((item: { idCategory: any; category: any; }) => ({
            value: item.idCategory,   // map idCheck → value
            label: item.category      // map check → label
        }));
        setListCategories(ids3)
    }, [data]);


    const handleRefreshMovements = async () => {
        if (parameters.period) {

            try {
                setLoading(true)
                const idBookingTypes: number[] = selectedBookingTypes
                    .map(opt => opt.value ? Number(opt.value) : undefined) // convert string → number
                    .filter((v): v is number => v !== undefined);
                const idGroupTypes: number[] = selectedGroupTypes
                    .map(opt => opt.value ? Number(opt.value) : undefined) // convert string → number
                    .filter((v): v is number => v !== undefined);
                const idCategories: number[] = selectedCategories
                    .map(opt => opt.value ? Number(opt.value) : undefined) // convert string → number
                    .filter((v): v is number => v !== undefined);

                const bodyObject: any = {
                    orderBy: "dateStart",
                    order: "desc",
                    limit: 1000,
                    columns: "idBooking, registration, model, make, obsBooking, dateStart, dateEnd, bookingDays, dateSubmited, equipmentType, idEquipment, idUser,  bookingType, groupType, displayName, groupTypeMaster, groupTypeMasterCode, category, instructor, towType, pax"
                };
                if (parameters.period !== "") {
                    bodyObject.month = parameters.period.split("-")[1];
                    bodyObject.year = parameters.period.split("-")[0];
                }
                if (idBookingTypes !== undefined && idBookingTypes.length > 0) {
                    bodyObject.idBookingTypes = idBookingTypes;
                }
                if (idGroupTypes !== undefined && idGroupTypes.length > 0) {
                    bodyObject.idGroupTypes = idGroupTypes;
                }
                if (idCategories !== undefined && idCategories.length > 0) {
                    bodyObject.idCategories = idCategories;
                }
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/bookings/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify(bodyObject),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                if (data.code == 0) {
                    if (data.bookings.length === 0) {
                        addNotificationStatus(data, setData);
                    } else {
                        const ws = XLSX.utils.json_to_sheet(data.bookings);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, "Movements");
                        XLSX.writeFile(wb, `Reservas.${parameters.period}.xlsx`);
                    }

                } else {
                    addNotificationStatus(data, setData);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }
    return (
        <CustomAppLayout
            toolsHide
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">

                        <Header actions={<Favorites />}>
                            Descarga de archivo de reservas
                        </Header>
                        <Container>
                            <Form>
                                <SpaceBetween direction="vertical" size="xs">
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <FormField label="Periodo">
                                            <div style={{ width: 130 }}>

                                                <MPModal
                                                    width={120}
                                                    today prevMonth nextMonth
                                                    end={new Date()}
                                                    date={`${parameters.period}`}
                                                    onConfirm={(date) => {
                                                        setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                                    }}
                                                />
                                            </div>

                                        </FormField>
                                        <FormField label="&nbsp;">
                                            <Button onClick={handleRefreshMovements} style={{ root: btnIconForm }} disabled={parameters.year === "" || parameters.month === ""}><Icon path={mdiFileExcel} size={1} /></Button>
                                        </FormField>
                                    </SpaceBetween>
                                    <FormField label="Tipo de vuelo">
                                        <Multiselect
                                            filteringType="auto"
                                            selectedOptions={selectedBookingTypes}
                                            onChange={({ detail }) =>
                                                setSelectedBookingTypes([...detail.selectedOptions])
                                            }
                                            options={listBookingTypes}
                                            placeholder="Seleccione uno o más tipos"
                                        />
                                    </FormField>
                                    <FormField label="Tipo de aeronave">
                                        <Multiselect
                                            filteringType="auto"
                                            selectedOptions={selectedGroupTypes}
                                            onChange={({ detail }) =>
                                                setSelectedGroupTypes([...detail.selectedOptions])
                                            }
                                            options={listGroupTypes}
                                            placeholder="Seleccione uno o más tipos"
                                        />
                                    </FormField>
                                    <FormField label="Categoría de aeronave">
                                        <Multiselect
                                            filteringType="auto"
                                            selectedOptions={selectedCategories}
                                            onChange={({ detail }) =>
                                                setSelectedCategories([...detail.selectedOptions])
                                            }
                                            options={listCategories}
                                            placeholder="Seleccione uno o más tipos"
                                        />
                                    </FormField>
                                </SpaceBetween>
                            </Form>
                        </Container>
                    </SpaceBetween>
                </>
            }
        />
    );
};
